"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsivePropType = exports.normalizeResponsiveProp = exports.breakpointPrefix = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const breakpointPrefix = (breakpoint = '') => {
  return breakpoint ? `${breakpoint}-` : '';
};

exports.breakpointPrefix = breakpointPrefix;

const normalizeResponsiveProp = value => {
  const responsiveMap = { ...((0, _isPlainObject.default)(value) ? value : {
      '': value
    })
  }; // Treat mobile as default.

  if (responsiveMap.mobile) {
    responsiveMap[''] = responsiveMap.mobile;
    delete responsiveMap.mobile;
  }

  return responsiveMap;
};

exports.normalizeResponsiveProp = normalizeResponsiveProp;

const responsivePropType = propType => _propTypes.default.shape({
  mobile: propType,
  tablet: propType,
  desktop: propType
});

exports.responsivePropType = responsivePropType;